/**
 * Scheme allowlist gate for `<a href={...}>` when the URL comes from a
 * server-fed string. React does NOT sanitize href attributes —
 * `<a href={"javascript:alert(1)"}>` will execute on click. Today the
 * SearchHitDto pipeline only emits https Drive URLs and (rarely) mailto:
 * links, so no exploit exists, but ADR 0039's resume-replay path means
 * stale historical sources can re-surface in any caller's resumed thread,
 * lengthening the window any future bad value would have to land in.
 *
 * Anything outside this small set returns `undefined` so the caller can
 * drop the anchor and render a defanged variant. Security audit CF.5.
 *
 * Markdown rendering goes through `rehype-sanitize`, which has its own
 * scheme allowlist for anchor hrefs, so this helper is for hand-rolled
 * `<a>` elements (SourcesList today; other surfaces if added later).
 */
const SAFE_SCHEMES = new Set(['https:', 'mailto:']);

export function safeHref(u: string | undefined | null): string | undefined {
  if (!u) return undefined;
  try {
    return SAFE_SCHEMES.has(new URL(u).protocol) ? u : undefined;
  } catch {
    return undefined;
  }
}
